import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-circle" }
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = ["cx", "cy", "r", "stroke", "stroke-width"]
const _hoisted_4 = ["cx", "cy", "r", "stroke", "stroke-width", "stroke-dasharray", "stroke-dashoffset", "transform"]
const _hoisted_5 = ["y"]
const _hoisted_6 = ["x", "dy", "font-size"]
const _hoisted_7 = ["x", "dy", "font-size"]

import { isDesktop } from '@/utils/responsiveHelper';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressCircle',
  props: {
  score: Number,
  size: {
    type: Number,
    default: !isDesktop() ? 150 : 250
  },
  strokeWidth: {
    type: Number,
    default: 14
  },
  trackColor: {
    type: String,
    default: '#1f242f'
  },
  progressColor: {
    type: String,
    default: '#9E77ED'
  }
},
  setup(__props) {

const props = __props;

const radius = computed(() => (props.size + props.strokeWidth / 2) / 2);
const circumference = computed(() => 2 * Math.PI * radius.value);
const dashOffset = computed(
  () => circumference.value * (1 - props.score / 500)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", {
      width: __props.size,
      height: __props.size
    }, [
      _createElementVNode("circle", {
        cx: radius.value,
        cy: radius.value,
        r: radius.value - __props.strokeWidth,
        stroke: __props.trackColor,
        "stroke-width": __props.strokeWidth,
        fill: "none"
      }, null, 8, _hoisted_3),
      _createElementVNode("circle", {
        cx: radius.value,
        cy: radius.value,
        r: radius.value - __props.strokeWidth,
        stroke: __props.progressColor,
        "stroke-width": __props.strokeWidth,
        "stroke-dasharray": circumference.value,
        "stroke-dashoffset": dashOffset.value,
        fill: "none",
        "stroke-linecap": "round",
        transform: `rotate(-90 ${radius.value} ${radius.value})`
      }, null, 8, _hoisted_4),
      _createElementVNode("text", {
        x: "50%",
        y: !_unref(isDesktop)() ? '31%' : '35%',
        "text-anchor": "middle",
        "dominant-baseline": "central",
        fill: "white"
      }, [
        _createElementVNode("tspan", {
          x: !_unref(isDesktop)() ? '54%' : '50%',
          dy: !_unref(isDesktop)() ? '15px' : '0px',
          fill: "#94969C",
          "font-size": !_unref(isDesktop)() ? '12' : '24'
        }, " Total Points ", 8, _hoisted_6),
        _createElementVNode("tspan", {
          x: !_unref(isDesktop)() ? '53%' : '50%',
          dy: !_unref(isDesktop)() ? '30px' : '60px',
          fill: "white",
          "font-size": !_unref(isDesktop)() ? '30px' : '60px'
        }, _toDisplayString(__props.score), 9, _hoisted_7)
      ], 8, _hoisted_5)
    ], 8, _hoisted_2))
  ]))
}
}

})